import React, {useEffect, useRef, useState} from 'react';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import ArrowRightIcon from '@mui/icons-material/ArrowRight';
import { Box } from '@mui/material';
import Skeleton from '@mui/material/Skeleton';
import useAxiosProtect from '../hooks/useAxiosProtect';
import { useNavigate } from 'react-router-dom';

const OppPreview = props => {
    var init = useRef(true);
    const [isLoading, setIsLoading] = useState(true);
    const [siteName, setSiteName] = useState('');
    const [oppCount, setOppCount] = useState(0);

    const axiosProtect = useAxiosProtect();
    const navigate = useNavigate();

    useEffect(() => {
        if(!init.current) return;
        init.current = false;

        axiosProtect.get(`/opp/opportunities/site-opp-metadata?siteID=${props.siteID}`).then(response => {
            setSiteName(response.data.siteName);
            setOppCount(response.data.oppCount);
            setIsLoading(false);
        }).catch(error => {

        });
    }, []);

    return (
        <Card sx={{mb: 2,boxShadow: 2,borderRadius: 2,backgroundColor: "#fafafa",}}>
            <CardContent>
                <Box sx={{display: "flex", alignItems: "center", justifyContent: "space-between"}}>
                    <Box style={{width:'100%', height:'100%'}}>
                        {
                            isLoading ? 
                            <Skeleton variant="rectangular" width='74vw' height='8vh' /> 
                            :
                            <>
                            <Typography variant="h6" sx={{ mb: 0.5 }}><strong>{siteName}</strong></Typography>
                            <Typography sx={{ color: "text.secondary" }}>{oppCount} opportunit{oppCount === 1 ? 'y' : 'ies'}</Typography>
                            </>
                        }
                    </Box>
                    <Box sx={{width: 40, height: 40, borderRadius: "50%", backgroundColor: "#d0d0d0", display: "flex", alignItems: "center", justifyContent: "center", transition: "0.2s",}}>
                        {!isLoading && <ArrowRightIcon onClick={() => navigate(`/site-opportunities/${props.siteID}`)} sx={{ fontSize: 28, color: "#333", cursor:'pointer' }} />}
                    </Box>
                </Box>
            </CardContent>
        </Card>
    )
}

export default OppPreview;